import React, { useEffect, useMemo } from 'react';
import L from 'leaflet';
import { Marker, useMap } from 'react-leaflet';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { AppState } from '../../../store/interfaces';
import { setDriverPin, setNewPin, setSelectedObject } from '../../../store/map/actions';
import { GeoButton } from '../GeoButton';

interface DriverMarkerProps {
  isEditMode: boolean;
}

export const DriverMarker: React.FC<DriverMarkerProps> = React.memo(function ({ isEditMode }) {
  const driverPin = useSelector((app: AppState) => app.map.driverPin, shallowEqual);
  const dispatch = useDispatch();
  const map = useMap();

  useEffect(() => {
    map.locate({ enableHighAccuracy: false });
    map.on('locationfound', async (event) => {
      dispatch(
        setDriverPin({
          address: '',
          position: event.latlng,
          isDriverCoords: true,
        })
      );
    });
  }, []);

  const eventHandlers = useMemo(() => {
    return {
      click: () => {
        if (!driverPin) {
          return;
        }

        if (isEditMode) {
          dispatch(setNewPin(driverPin));
          return;
        }

        dispatch(setSelectedObject(driverPin));
      },
    };
  }, [driverPin, dispatch]);

  if (driverPin === null || !driverPin.position) {
    return null;
  }

  const icon = L.icon({
    iconUrl: '/assets/map/driver.svg',
    iconSize: [25, 25],
  });

  return (
    <>
      <GeoButton />
      <Marker eventHandlers={eventHandlers} icon={icon} position={driverPin.position} />
    </>
  );
});
